import {
  FRAGMENT_USER_PROFILE_CORE,
  FRAGMENT_COMPANY_PROFILE_CORE,
  FRAGMENT_LOCATION_CORE,
  FRAGMENT_NEWS_LIST_CORE
} from './fragments'

export const AUTH_REGISTER = `
mutation AuthRegister (
  $input: AuthRegisterInput!
) {
  auth_register (
    input: $input
  )
}
`

export const AUTH_VERIFY_REGISTER = `
mutation AuthVerifyRegister (
  $token: String!
) {
  auth_verify_register (
    token: $token
  ) {
    access_token
  }
}
`

export const AUTH_LOGIN = `
mutation AuthLogin (
  $input: AuthLoginInput!
) {
  auth_login (
    input: $input
  ) {
    access_token
  }
}
`

export const AUTH_LOGOUT = `
mutation AuthLogout () {
  auth_logout (
    _: false
  )
}
`

export const AUTH_FORGET_PASSOWRD = `
mutation AuthForgetPassword (
  $userName: String!
) {
  auth_forget_password (
    username: $userName
  )
}
`

export const AUTH_RESET_PASSWORD = `
mutation AuthResetPassword (
  $input: AuthResetPasswordInput!
) {
  auth_reset_password (
    input: $input
  ) {
    access_token
  }
}
`

export const CREATE_COMPANY_PROFILE = `
mutation CreateCompanyProfile (
  $input: CreateCompanyProfileInput!
  $profileFile: Upload
) {
  create_company_profile (
    input: $input
    profileFile: $profileFile
  ) {
    ...fragmentCompanyProfileCore
  }
}
${FRAGMENT_COMPANY_PROFILE_CORE}
`

export const UPDATE_USER_PROFILE = `
mutation UpdateUserProfile (
  $input: UpdateUserProfile
  $profileFile: Upload
) {
  update_user_profile (
    input: $input
    profileFile: $profileFile
  ) {
    ...fragmentUserProfileCore
  }
}
${FRAGMENT_USER_PROFILE_CORE}
`

export const UPDATE_USER_PASSWORD = `
mutation UpdateUserPassword (
  $input: UpdateUserPassword!
) {
  update_user_password(
    input: $input
  )
}
`

export const UPDATE_COMPANY_PROFILE = `
mutation UpdateCompanyProfile (
  $input: UpdateCompanyProfileInput!
  $profileFile: Upload
) {
  update_company_profile (
    input: $input
    profileFile: $profileFile
  ) {
    ...fragmentCompanyProfileCore
  }
}
${FRAGMENT_COMPANY_PROFILE_CORE}
`

export const CREATE_SHOP_LOCATION = `
mutation CreateLocation (
  $input: CreateLocationInput!
) {
  create_location (
    input: $input
  ) {
    ...fragmentLocationCore
  }
}
${FRAGMENT_LOCATION_CORE}
`

export const DELETE_SHOP_LOCATION = `
mutation DeleteLocation (
  $input: DeleteLocationInput!
) {
  delete_location (
    input: $input
  )
}
`

export const CREATE_NEWS_POST = `
mutation CreateNewsPost (
  $input: CreateNewsPostInput!
  $files: [Upload]
) {
  create_news_post (
    input: $input
    files: $files
  ) {
    ...fragmentNewsListCore
  }
}
${FRAGMENT_NEWS_LIST_CORE}
`

export const TAKE_NEWS_POST_ACTION = `
mutation TakeNewsPostAction (
  $input: TakeNewsPostActionInput!
) {
  take_news_post_action (
    input: $input
  ) {
    _id
  }
}
`